import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-contact-confirmation-modal',
    templateUrl: './contact-confirmation-modal.component.html',
    styleUrls: ['./contact-confirmation-modal.component.scss'],
})

export class ContactConfirmationModalComponent{
    loading: boolean = false;
    constructor(
        protected ref: MatDialogRef<ContactConfirmationModalComponent>,
    ) {
    }

    close() {
        this.ref.close();
    }


}
